// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"248":"5ed8c41a0a49a84fb36f","862":"7ea79af5e7f8e5ffccc6"}[chunkId] + ".2209.js";
};